import React, { useEffect } from 'react';
import { Button } from 'antd';
import NetworkIcon from 'components/NetworkIcon';
import useAccountConnectionFlow from 'components/AccountConnectionFlow/AccountConnectionFlow.provider';
import { snackbar } from 'components/notifications/notifications';
import useBingLogin from 'modules/network-accounts/hooks/useBingLogin';
import { useConnectBingAdsMutation } from 'modules/apps/apps/BingAdsApp/api/bing-ads.api';
import { socketEvents } from 'utils/socket/socket-events';

const ConnectBingAdsStep = () => {
  const flow = useAccountConnectionFlow();
  const { loading: authLoading, connectLoading, openLogin: openBingAdsLoginPopup } = useBingLogin();

  /**
   * Responsible for connecting BingAds accounts to MyDataNinja
   * Gets the SDK response from BingAds and then connects the accounts to MyDataNinja
   */
  const connectBingAds = async () => {
    const onSuccess = (data) => {
      window.bingConnectionWindow?.close();
      flow.setConnectionBatch(data.connection_batch);
      flow.changeStep('choose_accounts');
    };

    const onError = () => {};

    const snack = snackbar.loading('Connecting to Bing Ads...');

    // Open login dialog only, others are handled by the socket
    openBingAdsLoginPopup().catch((err) => {
      snack.update('Error while connecting Bing Ads to MyDataNinja', {
        type: 'error',
      });
    });

    socketEvents.on('bing_connect_error', function () {
      snack.update('Error connecting Bing Ads', {
        type: 'error',
      });
      onError();
    });

    socketEvents.on('bing_connect_success', function (data) {
      if (!data.connection_batch) {
        snack.update('Error while connecting accounts to MyDataNinja', {
          type: 'error',
        });
        return;
      }

      snack.update('Successfully Connected', {
        type: 'success',
      });
      onSuccess(data);
    });
  };

  useEffect(() => {
    return () => {
      socketEvents.removeListener('bing_connect_success');
      socketEvents.removeListener('bing_connect_error');
    };
  }, []);

  return (
    <div className='w-full flex-center pt-8'>
      <Button
        onClick={connectBingAds}
        type='dashed'
        size='large'
        loading={authLoading || connectLoading}
        icon={<NetworkIcon network='bing' />}
      >
        {flow.loading
          ? 'Please Finish connection or refresh'
          : 'Click Here To Connect Your BingAds Ad Accounts'}
      </Button>
    </div>
  );
};

export default ConnectBingAdsStep;
